import {
  PROPOSAL_INIT_LOADING,
  PROPOSAL_INIT_SUCCESS,
  PROPOSAL_INIT_FAIL,
  PROPOSAL_LISTING_LOADING,
  PROPOSAL_LISTING_SUCCESS,
  PROPOSAL_LISTING_FAIL,
  PROPOSAL_DETAILS_INIT_LOADING,
  PROPOSAL_DETAILS_INIT_SUCCESS,
  PROPOSAL_DETAILS_INIT_FAIL,
  PROPOSAL_DETAILS_LOAD_DATA,
  PROP_COVER_DET_INIT_LOADING,
  PROP_COVER_DET_INIT_SUCCESS,
  PROP_COVER_DET_INIT_FAIL,
  PROPOSAL_REVIEW_MODE,
  PROPOSAL_QUERY_MODE,
  PROPOSAL_CONVERT_MODE
} from '@/store/types'

export const general = {
  [PROPOSAL_INIT_LOADING](state) {
    state.init = 0
    state.initErr = []
    state.menu = {}
  },
  [PROPOSAL_INIT_SUCCESS](state, data) {
    state.init = 1
    state.initErr = []
    state.menu = data.menu
  },
  [PROPOSAL_INIT_FAIL](state, error) {
    state.init = 2
    state.initErr = error
    state.menu = {}
  },
  [PROPOSAL_LISTING_LOADING](state) {
    state.proposalListing.init = 0
    state.proposalListing.initErr = []
    state.proposalListing.menu = {}
  },
  [PROPOSAL_LISTING_SUCCESS](state, data) {
    state.proposalListing.init = 1
    state.proposalListing.initErr = []
    state.proposalListing.menu = data.menu
  },
  [PROPOSAL_LISTING_FAIL](state, error) {
    state.proposalListing.init = 0
    state.proposalListing.initErr = error
    state.proposalListing.menu = {}
  },
  [PROPOSAL_DETAILS_INIT_LOADING](state) {
    state.proposalDetails.init = 0
    state.proposalDetails.initErr = []
    state.proposalDetails.menu = {}
  },
  [PROPOSAL_DETAILS_INIT_SUCCESS](state, data) {
    state.proposalDetails.init = 1
    state.proposalDetails.initErr = []
    state.proposalDetails.menu = data.menu
  },
  [PROPOSAL_DETAILS_INIT_FAIL](state, error) {
    state.proposalDetails.init = 2
    state.proposalDetails.initErr = error
    state.proposalDetails.menu = {}
  },
  [PROP_COVER_DET_INIT_LOADING](state) {
    state.coverageDetails.init = 0
    state.coverageDetails.initErr = []
    state.coverageDetails.menu = {}
  },
  [PROP_COVER_DET_INIT_SUCCESS](state, data) {
    state.coverageDetails.init = 1
    state.coverageDetails.initErr = []
    state.coverageDetails.menu = data.menu
  },
  [PROP_COVER_DET_INIT_FAIL](state, error) {
    state.coverageDetails.init = 2
    state.coverageDetails.initErr = error
    state.coverageDetails.menu = {}
  },
  [PROPOSAL_REVIEW_MODE](state) {
    state.proposalMode = 'Review'
  },
  [PROPOSAL_QUERY_MODE](state) {
    state.proposalMode = 'Query'
  },
  [PROPOSAL_CONVERT_MODE](state) {
    state.proposalMode = 'Convert'
  },
  [PROPOSAL_DETAILS_LOAD_DATA](state, fullData) {
    const { data } = fullData
    state.proposalDetails.propInfo.propNo = data.propNo
    state.proposalDetails.propInfo.ipcNo = data.ipcNo
    state.proposalDetails.propInfo.ipcSeqNo = data.ipcSeqNo
    state.proposalDetails.propInfo.polNo1 = data.polNo1
    state.proposalDetails.propInfo.polNo2 = data.polNo2
    state.proposalDetails.propInfo.polType = data.polType
    state.proposalDetails.propInfo.polTypeDesc = data.polTypeDesc
    state.proposalDetails.propInfo.scheme = data.scheme
    state.proposalDetails.propInfo.planNo = data.planNo
    state.proposalDetails.propInfo.branch = data.branch
    state.proposalDetails.propInfo.agent = data.agent
    state.proposalDetails.propInfo.busSrc = data.busSrc
    state.proposalDetails.propInfo.name1 = data.name1
    state.proposalDetails.propInfo.name2 = data.name2
    state.proposalDetails.propInfo.name3 = data.name3
    state.proposalDetails.propInfo.addr1 = data.addr1
    state.proposalDetails.propInfo.addr2 = data.addr2
    state.proposalDetails.propInfo.addr3 = data.addr3
    state.proposalDetails.propInfo.addr4 = data.addr4
    state.proposalDetails.propInfo.postCode = data.postCode
    state.proposalDetails.propInfo.telNo = data.telNo
    state.proposalDetails.propInfo.mobileNo = data.mobileNo
    state.proposalDetails.propInfo.faxNo = data.faxNo
    state.proposalDetails.propInfo.email = data.email
    state.proposalDetails.propInfo.comDate = data.comDate
    state.proposalDetails.propInfo.expDate = data.expDate
    state.proposalDetails.propInfo.propDate = data.propDate
    state.proposalDetails.propInfo.fininst = data.fininst
    state.proposalDetails.propInfo.finBrn = data.finBrn
    state.proposalDetails.propInfo.finConPer = data.finConPer
    state.proposalDetails.propInfo.finTelNo = data.finTelNo
    state.proposalDetails.propInfo.finFaxNo = data.finFaxNo
    state.proposalDetails.propInfo.siCurr = data.siCurr
    state.proposalDetails.propInfo.totSI = data.totSI
    state.proposalDetails.propInfo.grossAnnPrem = data.grossAnnPrem
    state.proposalDetails.propInfo.paytMeth = data.paytMeth
    state.proposalDetails.propInfo.crCdGIRO = data.crCdGIRO
    state.proposalDetails.propInfo.acctName1 = data.acctName1
    state.proposalDetails.propInfo.acctName2 = data.acctName2
    state.proposalDetails.propInfo.freeInsRem = data.freeInsRem
    state.proposalDetails.propInfo.freeInsFr = data.freeInsFr
    state.proposalDetails.propInfo.freeInsTo = data.freeInsTo
    state.proposalDetails.propInfo.hdbReplCost = data.hdbReplCost
    state.proposalDetails.propInfo.propStat = data.propStat
    state.proposalDetails.propInfo.propStatDesc = data.propStatDesc
    state.proposalDetails.propInfo.progId = data.progId
    state.proposalDetails.propInfo.comment1 = data.comment1
    state.proposalDetails.propInfo.comment2 = data.comment2
    state.proposalDetails.propInfo.typeProp = data.typeProp
    state.proposalDetails.propInfo.occpClass = data.occpClass
    state.proposalDetails.propInfo.area = data.area
    state.proposalDetails.propInfo.gdsManuf = data.gdsManuf
    state.proposalDetails.propInfo.loc1 = data.loc1
    state.proposalDetails.propInfo.loc2 = data.loc2
    state.proposalDetails.propInfo.loc3 = data.loc3
    state.proposalDetails.propInfo.loc4 = data.loc4
    state.proposalDetails.propInfo.locPostCode = data.locPostCode
    state.proposalDetails.propInfo.propType = data.propType
    state.proposalDetails.propInfo.schbusClsDesc = data.schbusClsDesc
    state.proposalDetails.propInfo.planDesc = data.planDesc
    state.proposalDetails.propInfo.paytMethDesc = data.paytMethDesc
    state.proposalDetails.propInfo.abbrevName = data.abbrevName
  }
}
